import { useFeatureFlag } from '@platform/feature-flags';
import { useEffect } from 'react';
import { router } from './router';

export function RouterPreloadSync() {
  const preloadEnabled = useFeatureFlag('route-preloading');

  useEffect(() => {
    // Cast needed: router.update() types require `context` but it's optional at runtime for partial updates.
    router.update({ defaultPreload: preloadEnabled ? 'intent' : false } as Parameters<typeof router.update>[0]);
  }, [preloadEnabled]);

  return null;
}
